import { Card } from '@/components/ui/card';
import { t } from '@/i18n';

const Value = ({ median, p90 }) => (
  <>
    <div className="font-semibold tabular-nums">{median} min</div>
    <div className="text-[11px] tabular-nums text-muted-foreground">{t('stats.site.p90')}: {p90} min</div>
  </>
);

// Median and 90th percentile of the times on site per loading type (silo vs. pallets).
export const DwellTimes = ({ rows }) => (
  <Card className="p-0 overflow-hidden">
    <div className="px-4 pt-3 pb-2">
      <div className="text-sm font-semibold">{t('stats.site.dwellTitle')}</div>
      <div className="text-xs text-muted-foreground">{t('stats.site.dwellHint')}</div>
    </div>
    <table className="w-full text-sm">
      <thead className="bg-muted/50 text-xs text-muted-foreground">
        <tr>
          <th className="text-left font-medium px-4 py-2" />
          <th className="text-right font-medium px-3 py-2">{t('stats.site.silo')}</th>
          <th className="text-right font-medium px-4 py-2">{t('stats.site.pallet')}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(r => (
          <tr key={r.key} className="border-t">
            <td className="px-4 py-2.5">{t(`stats.site.${r.key}`)}</td>
            <td className="px-3 py-2.5 text-right"><Value {...r.silo} /></td>
            <td className="px-4 py-2.5 text-right"><Value {...r.pallet} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </Card>
);
